
import { useEffect, useState } from 'react'
import Header from './components/Header/Header'
import Hero from './components/Hero/Hero'
import Loading from './components/Loading/Loading'
import ProcessSteps from './components/ProcessSteps'
import SplitSection from './components/SplitSection'
import Faq from './components/Faq'
import Footer from './components/Footer'
import Testimonials from './components/Testimonials'
import TrustNumbers from './components/TrustNumbers'
import WhyChoose from './components/WhyChoose'
import WhatsappFloat from './components/WhatsappFloat'
import Links from './components/Links'
// import StackSplit from './components/StackSplit'

function Home() {
  const [loading, setLoading] = useState(true)
  const [fade, setFade] = useState(false)

  useEffect(() => {
    // mostra o loading por 1.6s, então dispara fade e remove após transição
    const showTime = 1600
    const fadeDuration = 420

    const t1 = setTimeout(() => setFade(true), showTime)
    const t2 = setTimeout(() => setLoading(false), showTime + fadeDuration)

    return () => {
      clearTimeout(t1)
      clearTimeout(t2)
    }
  }, [])

  return (
    <>
      {loading ? <Loading fade={fade} /> : null}
      <Header />
      <main>
        <Hero animate={!loading} />

        {/* Seção com social proof e cases */}
        <SplitSection
          id="clientes"
          left={
            <div>
              <h2>Empresas e profissionais que confiam no meu trabalho</h2>
              <p>
                Já ajudei centenas de clientes a marcarem presença online. Meus sites são
                criados para gerar credibilidade e atrair novos clientes. Confira alguns cases:
              </p>
            </div>
          }
        />

        <ProcessSteps id="como-funciona" />

        <TrustNumbers />

        <WhyChoose id="vantagens" />

        <Testimonials id="depoimentos" />

        <Faq />

        {/* Removido StackSplit para manter apenas uma faixa cinza e uma branca */}
      </main>
      <Footer />
      <WhatsappFloat />
    </>
  )
}

function App() {
  const rawPath = typeof window !== 'undefined' ? window.location.pathname : '/'
  const normalizedPath = rawPath.endsWith('/') && rawPath.length > 1 ? rawPath.slice(0, -1) : rawPath
  const isLinksRoute = normalizedPath === '/links'

  if (isLinksRoute) {
    return <Links />
  }

  return <Home />
}

export default App
